const MaterialLogicMindMap = () => import('@/views/main/promotion/materialLogicMindMap/MaterialLogicMindMap.vue')
export default {
  path: '/main/promotion/materialLogicMindMap',
  name: 'MaterialLogicMindMap',
  component: MaterialLogicMindMap
}
